import {createSlice} from '@reduxjs/toolkit';

interface IPaymentInit {
  token: string;
  advanceId: string;
}

const initialState: IPaymentInit = {
  token: '',
  advanceId: '',
};

const paymentReducerSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentToken(state, actions) {
      state.token = actions.payload;
    },
    setAdvanceId(state, actions) {
      state.advanceId = actions.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

const paymentReducer = paymentReducerSlice.reducer;

export const paymentActions = paymentReducerSlice.actions;

export default paymentReducer;
